import { render, staticRenderFns } from "./FnFormatSwitch.vue?vue&type=template&id=dcfcaba4&"
import script from "./FnFormatSwitch.vue?vue&type=script&lang=js&"
export * from "./FnFormatSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dcfcaba4')) {
      api.createRecord('dcfcaba4', component.options)
    } else {
      api.reload('dcfcaba4', component.options)
    }
    module.hot.accept("./FnFormatSwitch.vue?vue&type=template&id=dcfcaba4&", function () {
      api.rerender('dcfcaba4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-format/components/FnFormatSwitch.vue"
export default component.exports